export const ERROR_CODES = Object.freeze({
	UNAUTHENTICATED: 'UNAUTHENTICATED',
	WRONG_CREDENTIALS: 'WRONG_CREDENTIALS',
	EMAIL_REQUIRED: 'EMAIL_REQUIRED',
	EMAIL_INVALID: 'EMAIL_INVALID',
	EMAIL_TAKEN: 'EMAIL_TAKEN',
	USERNAME_REQUIRED: 'USERNAME_REQUIRED',
	USERNAME_TAKEN: 'USERNAME_TAKEN',
	PASSWORD_REQUIRED: 'PASSWORD_REQUIRED',
	PASSWORD_TOO_SHORT: 'PASSWORD_TOO_SHORT',
	PASSWORD_TOO_LONG: 'PASSWORD_TOO_LONG',
	PASSWORD_NOT_EDITABLE: 'PASSWORD_NOT_EDITABLE',
	CURRENT_PASSWORD_WRONG: 'CURRENT_PASSWORD_WRONG',
	PASSWORD_UNCHANGED: 'PASSWORD_UNCHANGED',
	BIO_TOO_LONG: 'BIO_TOO_LONG',
	CAPTION_INVALID: 'CAPTION_INVALID',
	CAPTION_TOO_LONG: 'CAPTION_TOO_LONG',
	IMAGE_TYPE_INVALID: 'IMAGE_TYPE_INVALID',
	IMAGE_TOO_LARGE: 'IMAGE_TOO_LARGE',
	USER_NOT_FOUND: 'USER_NOT_FOUND',
	POST_NOT_FOUND: 'POST_NOT_FOUND',
	POST_FORBIDDEN: 'POST_FORBIDDEN',
	COMMENT_TEXT_REQUIRED: 'COMMENT_TEXT_REQUIRED',
	COMMENT_NOT_FOUND: 'COMMENT_NOT_FOUND',
	PROFILE_FORBIDDEN: 'PROFILE_FORBIDDEN',
	TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
	DEMO_UNAVAILABLE: 'DEMO_UNAVAILABLE',
	INTERNAL_ERROR: 'INTERNAL_ERROR',
});

const KNOWN_ERROR_CODES = new Set(Object.values(ERROR_CODES));

export const isKnownErrorCode = (code) => KNOWN_ERROR_CODES.has(code);
